import getTabById from '../utils/getTabById';
import { getTabHandler } from '../utils/TabHandler';

export default function onBeforeCloseMainWindow(tabId: string): string | null {
    const tab = getTabById(tabId);
    const handler = getTabHandler(tab?.type);
    return handler?.onBeforeCloseMainWindow?.(tab) || null;
}
